import React, { useMemo, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../generic-components/Button';
import Heading from '../../../../../generic-components/Heading';
import { ClientProfile } from './ClientProfile';
import { IInvoiceRecipient } from '../../types/types';
import { STYLES } from '../../consts/consts';
import { ReactComponent as PlusIcon } from '../../../../../assets/svg/plus-new.svg';

const { INVOICE_CREATION: { CLIENTS_AUTO_COMPLETE: componentStyles } } = STYLES;

interface IProps {
  keyword:string;
  elActivatorId: string;
  close: () => void;
  onClientSelection: (vendorId:string) => void;
  onCreateNewClient: (isInitialName?: boolean) => void;
  recipientList: IInvoiceRecipient[];
}

export const ClientsAutoComplete = ({
  keyword, close, elActivatorId, recipientList, onClientSelection, onCreateNewClient,
}: IProps) => {
  const elContainer = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  const filteredList = useMemo(() => {
    if (!recipientList) return [];
    return recipientList?.filter(client => client?.name?.toLowerCase().includes(keyword.toLowerCase()));
  }, [keyword]);

  const handleCreateNewClient = () => {
    const shouldSetInitialName = !!((!filteredList.length && keyword));
    onCreateNewClient(shouldSetInitialName);
  };

  const getActionTitle = useMemo(() => {
    if (!filteredList.length && keyword) {
      return `${t('INVOICE_CREATION.INVOICE_CLIENT_SECTION.CLIENTS_AUTO_COMPLETE.ADD_NEW_CLIENT')} "${keyword}"`;
    }
    return t('INVOICE_CREATION.INVOICE_CLIENT_SECTION.CLIENTS_AUTO_COMPLETE.CREATE_NEW_CLIENT');
  }, [filteredList]);

  useEffect(() => {
    window.addEventListener('click', (e: any) => {
      // @ts-ignore
      if (elContainer?.current?.contains(e.target) || e?.target?.id === elActivatorId) {
        // Clicked inside
      } else {
        close();
      }
    });
    return () => {
      window.removeEventListener('click', () => {});
    };
  }, []);

  return (
    <div ref={elContainer} className={componentStyles.WRAPPER}>
      {!!filteredList.length && filteredList.map((clientData) => (
        <div key={clientData.externalId} className={componentStyles.PROFILE_WRAPPER}>
          <ClientProfile onClick={() => onClientSelection(clientData.externalId)} clientData={clientData} />
        </div>
      ))}
      {(!filteredList.length && keyword) && (
      <div className={componentStyles.ZERO_STATE_LIST_WRAPPER}>
        <Heading title={t('INVOICE_CREATION.INVOICE_CLIENT_SECTION.CLIENTS_AUTO_COMPLETE.NO_CLIENT_FOUND')} className={componentStyles.ZERO_STATE_LIST_HEADER} />
      </div>
      )}

      <Button
        onClick={handleCreateNewClient}
        childElement={(
          <div className='flex items-center gap-[6px]'>
            <PlusIcon className='text-action03 w-[16px] h-[16px]' />
            <Heading title={getActionTitle} className={componentStyles.BUTTON_TITLE} />
          </div>
      )}
        className={`${componentStyles.BUTTON} ${!filteredList.length && keyword ? 'flex items-center justify-center' : ''}`}
        id='autoCompleteCreateNewClientButton'
      />
    </div>
  );
};
